import Avatar from "../Avatar/Avatar";
import {useSession} from "../../redux/Reducers/AuthReducer";
import {getUri, truchateString} from "../../utils/utils";
import {useState} from "react";
import ImagesBox from "../../pages/main/Community/components/images-Box";
import Icon from "../Icon/Icon";
import UploadFile from "../../API/UploadFile";
import StarsFilter from "../Filter/stars-filter";
import CommentType from "../../utils/comment-type";
import Filter from "../../pages/main/practice/component/Filter";
import {AiOutlineArrowDown} from "react-icons/ai";
import {useMemberShipModal} from "../../redux/Reducers/buy-membership-slice";

export default function CommentInputBox({className, onAddComment, ...props}) {
    const {session, authActions} = useSession();
    const [comment, setComment] = useState("")
    const [images, setImages] = useState([]);
    const [error, setError] = useState(null);
    const [commentType, setCommentType] = useState(CommentType[0]?.value)
    const [isOpen, actions] = useMemberShipModal();

    function clearForm() {
        setComment("")
        setError("")
        setImages([])
        setCommentType(CommentType[0]?.value)
    }

    function postComment() {
        if (!authActions.hasActiveSubscription()) {
            setError("You need to have an active subscription to comment")
            actions.open()
            return;
        }
        if (comment.trim().length !== 0) {
            if (onAddComment) onAddComment({
                text: comment, images: images.map((img) => img.id),
                comment_type: commentType
            })
            clearForm()
            return;
        }
        setError("Comment cannot be empty")
    }


    return (<div className={`bg-tertiary-150 flex gap-3 flex-col p-4 rounded-lg ${className}`}>
            <div className={"flex flex-row"}>
                <div className={"flex flex-row justify-center items-center gap-3 font-semibold"}>
                    <Avatar className={"w-12 h-12"} src={getUri(session?.profile?.dp_uri?.file)}/>
                    <p>
                        {truchateString(session?.profile?.full_name || "Anonymous", 15)}
                    </p>
                </div>

            </div>
            <textarea
                className={"bg-white rounded-lg h-32 px-3 focus:outline-none py-2"}
                value={comment}
                onChange={(e) => {
                    setComment(e.target.value)
                    setError("")
                }}

                placeholder={"Write a comment..."}
            />
            <div className={"flex flex-row gap-4 flex-wrap"}>
                {images.map((image, i) => (<ImagesBox key={image?.id} data={image} isForm onRemove={() => {
                    setImages(images.filter((img, index) => index !== i))
                }}/>))}

            </div>
            {error && <p className={"text-red-500 text-sm"}>
                {error}
            </p>}
            <div className={"flex flex-col-reverse md:flex-row justify-center md:items-center gap-4 md:gap-2"}>
                <div className={"flex flex-row gap-2"}>
                    <p onClick={postComment}
                       className={"bg-tertiary-900 px-5 py-1 rounded-lg cursor-pointer  text-white"}>
                        Comment
                    </p>
                    <button
                        onClick={() => {
                            clearForm()
                        }}
                        className={"text-gray-600"}>
                        Cancel
                    </button>
                </div>
                <div className={"flex flex-1 flex-row gap-2"}>

                    <label className={"w-full flex-1 flex gap-2 mr-4 items-center justify-end "}>
                        <p className={"text-sm font-bold text-secondary-900"}>
                            Comment Type
                        </p>
                        <StarsFilter
                            currentValue={commentType}
                            select={(value) => {
                                console.log(value)
                                setCommentType(value?.commenttype)
                            }}
                            {...{
                                title: "CommentType", options: CommentType
                            }}
                        />

                        <AiOutlineArrowDown className={"text-secondary-900"}/>
                    </label>
                    <label htmlFor={"imageInput"} className={"flex items-center justify-end "}>
                        <Icon
                            className={"self-end"}
                            name={"image-box"}
                        />
                    </label>
                    <input type={"file"}
                           onChange={(e) => {
                               UploadFile(e.target.files[0]).then((res) => {
                                   setImages([...images, res?.data])
                               })
                           }}
                           accept={"image/*"} className={"hidden"} id={"imageInput"}/>


                </div>
            </div>
        </div>

    )
}